var map = {
	"./symbol_0.png": 35386,
	"./symbol_1.png": 25219,
	"./symbol_10.png": 65707,
	"./symbol_11.png": 28226,
	"./symbol_12.png": 84313,
	"./symbol_13.png": 78064,
	"./symbol_14.png": 90287,
	"./symbol_15.png": 51270,
	"./symbol_16.png": 32477,
	"./symbol_17.png": 99444,
	"./symbol_18.png": 94739,
	"./symbol_2.png": 40859,
	"./symbol_3.png": 34014,
	"./symbol_4.png": 67070,
	"./symbol_5.png": 42855,
	"./symbol_6.png": 92172,
	"./symbol_7.png": 26178,
	"./symbol_8.png": 74642,
	"./symbol_9.png": 96187
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 86845;